import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
	path: '/',
	redirect: {
		name: 'index'
	},
	component: layoutHeaderAside,
	children: [
		{
			path: 'EpCompanyInfo',
			name: 'EpCompanyInfo',
			meta: {
				title: '防疫物资重点生产企业管理',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Other/EpCompanyInfo/EpCompanyInfo')
		},
		{
			path: 'StreetContactInfo',
			name: 'StreetContactInfo',
			meta: {
				title: '各行业街道联系表',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Other/StreetContactInfo/StreetContactInfo')
		},
		{
			path: 'TransportInfo',
			name: 'TransportInfo',
			meta: {
				title: '物资运力表',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Other/TransportInfo/TransportInfo')
		},
		{
			path: 'StoreReport2',
			name: 'StoreReport2',
			meta: {
				title: '按物资档案统计',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Report/StoreReport2/StoreReport2')
		},
		{
			path: 'StoreReport1',
			name: 'StoreReport1',
			meta: {
				title: '按批次号统计',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Report/StoreReport1/StoreReport1')
		},
		{
			path: 'AllocateInfo',
			name: 'AllocateInfo',
			meta: {
				title: '调拨与轮换',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Store/AllocateInfo/AllocateInfo')
		},
		{
			path: 'StoreOutInfo',
			name: 'StoreOutInfo',
			meta: {
				title: '出库单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Store/StoreOutInfo/StoreOutInfo')
		},
		{
			path: 'StoreInInfo',
			name: 'StoreInInfo',
			meta: {
				title: '入库单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Store/StoreInInfo/StoreInInfo')
		},
		{
			path: 'AreaInfo',
			name: 'AreaInfo',
			meta: {
				title: '仓库区域设置',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Basic/AreaInfo/AreaInfo')
		},
		{
			path: 'ItemInfo',
			name: 'ItemInfo',
			meta: {
				title: '物资档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Basic/ItemInfo/ItemInfo')
		},
		{
			path: 'MakeFactoryInfo',
			name: 'MakeFactoryInfo',
			meta: {
				title: '生产厂家档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Basic/MakeFactoryInfo/MakeFactoryInfo')
		},
		{
			path: 'SaleFactoryInfo',
			name: 'SaleFactoryInfo',
			meta: {
				title: '销售厂家档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Basic/SaleFactoryInfo/SaleFactoryInfo')
		},
		{
			path: 'NoticeInfo',
			name: 'NoticeInfo',
			meta: {
				title: '公告管理',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/NoticeInfo/NoticeInfo')
		},


		// 首页
		{
			path: 'index',
			name: 'index',
			meta: {
				auth: true
			},
			component: _import('system/index')
		},
		// 系统 前端日志
		{
			path: 'log',
			name: 'log',
			meta: {
				title: '前端日志',
				auth: true
			},
			component: _import('system/log')
		},
		// 刷新页面 必须保留
		{
			path: 'refresh',
			name: 'refresh',
			hidden: true,
			component: _import('system/function/refresh')
		},
		// 页面重定向 必须保留
		{
			path: 'redirect/:route*',
			name: 'redirect',
			hidden: true,
			component: _import('system/function/redirect')
		},
		// 下面都是我的页面：
		{
			path: 'UserInfo',
			name: 'UserInfo',
			meta: {
				title: '用户及权限',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/UserInfo/UserInfo')
		}, {
			path: 'UpdateLogInfo',
			name: 'UpdateLogInfo',
			meta: {
				title: '更新日志',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/UpdateLogInfo/UpdateLogInfo')
		}, {
			path: 'MenuInfo',
			name: 'MenuInfo',
			meta: {
				title: '系统菜单设置',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/MenuInfo/MenuInfo')
		},



	]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	}
]

/**
 * 错误页面
 */
const errorPage = [{
	path: '*',
	name: '404',
	component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]
